import { MessageCircle, X } from 'lucide-react';
import { useState } from 'react';

const WhatsAppButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [showTooltip, setShowTooltip] = useState(true);

  return (
    <div className="fixed bottom-8 right-8 z-50 flex items-center gap-4">
      {/* Tooltip */}

{isHovered && (
  <div className="position-relative d-inline-block">
    <div className="bg-[#21c063]   text-dark px-3 py-2 rounded shadow d-flex align-items-center gap-2">
      <span className='text-white'>¿Necesitas ayuda?</span>
    </div>

    {/* Flecha */}
    <div className="tooltip-arrow-left" />
  </div>
)}


      {/* Button */}
      <a
        href="https://wa.me/573112378357?text=Hola,%20me%20interesa%20conocer%20más%20sobre%20Sistema%20Rocky"
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="relative group"
        aria-label="Contactar por WhatsApp"
      >
        {/* Pulse Rings */}
        <span className="absolute inset-0 rounded-full bg-[#21c063] animate-pulse-ring" />
        <span className="absolute inset-0 rounded-full bg-[#21c063] animate-pulse-ring delay-300" />
        
        {/* Main Button */}
        <div className={`relative w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg transition-all duration-500 ${isHovered ? 'scale-110 shadow-xl' : ''}`}>
          <MessageCircle className="text-white transition-transform duration-300" size={28} style={{ transform: isHovered ? 'rotate(-15deg) scale(1.1)' : '' }} />
          
          {/* Shine Effect */}
          <div className="absolute inset-0 rounded-full overflow-hidden">
            <div className={`absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full transition-transform duration-700 ${isHovered ? 'translate-x-full' : ''}`} />
          </div>
        </div>

        {/* Online Indicator */}
        {/* <span className="absolute -top-1 -right-1 w-5 h-5 bg-gold rounded-full border-2 border-background flex items-center justify-center">
          <span className="w-2 h-2 bg-navy rounded-full animate-pulse" />
        </span> */}
      </a>
    </div>
  );
};

export default WhatsAppButton;
